<template>
<div>

      <div class="container mt_140">
          <ccMenu ref="cc_menu" v-bind:posicao=2></ccMenu>
          <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

          <div class="row">
              <div class="col-12">

                <div class="row mb-3">
                  <div class="col-md-2">
                    <select class="form-control form-control-sm" v-model="frm_torneio_tipo" @change="filtro_tipo(frm_torneio_tipo)">
                      <option value=0>Todos</option>
                      <option value=1>Um contra o outro</option>
                      <option value=2>Preço fixo</option>
                      <option value=3>Torneios grátis</option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <select class="form-control form-control-sm" v-model="frm_torneio_buy_in" @change="filtro_buy_in(frm_torneio_buy_in)">
                      <option value="all">Valor de entrada</option>
                      <option value="r1">0 - 5R$</option>
                      <option value="r2">R$5 - R$30</option>
                      <option value="r3">R$30 - R$100 </option>
                      <option value="r4">R$100 - em diante  </option>
                    </select>
                  </div>
                </div>

                <div class="row">
                    <div class="col-md-12 pt-2" style="background: linear-gradient(rgba(255, 255, 255, 0.05) 0%, rgba(128, 128, 128, 0) 100%); min-height: 500px;">
                      <div class="row">
                        <div class="col-md-8">
                            <div class="row mb-4">
                              <div class="col-2 text_branco text_bold">
                                TORNEIOS
                              </div>
                              <div class="col-md-3">
                                <router-link to="/meu_torneio/aguardando" class="btn btn-outline-success btn-sm w-100"> AGUARDANDO</router-link>
                              </div>
                              <div class="col-md-3">
                                <router-link to="/meu_torneio/andamento" class="btn btn-outline-success btn-sm w-100"> EM ANDAMENTO </router-link>
                              </div>
                              <div class="col-md-3">
                                <router-link to="/meu_torneio/historico" class="btn btn-success btn-sm w-100"> HISTÓRICO </router-link>
                              </div>
                            </div>
                        </div>
                      </div>

                      <div v-if="tor.length == 0" class="text_18 text_branco text-center">
                        Nenhum torneio encontrado.
                        <br><br> <br> <br> <br> <br>
                      </div>

                      <div v-if="tor.length > 0" v-for="t in tor" class="row mb-3">
                        <div class="col-md-12">
                          <div class="card text_branco p-3" @click="chamando_pagina_torneio(t.tor_id)" style="text-decoration: none; cursor:pointer;">


                            <!-- Torneio normais -->
                            <div v-if="t.tor_tipo_id == 1 || t.tor_tipo_id == 2 || t.tor_tipo_id == 3">
                              <div class="row">
                                <div class="col-md-8">
                                  <div class="text_17 text_bold text_branco" v-bind:class="[t.tor_tipo_id==1?'text_roxo':t.tor_tipo_id==2?'text_verde':'text_laranja']">
                                    {{t.tor_nome}}
                                  </div>
                                  <div class="text_14">
                                    <span class="text_ver">
                                      {{t.tor_descricao_pagamento}}
                                    </span>
                                  </div>
                                </div>
                                <div class="col-4 text_12 text_bold text_cinza text-end">
                                  <div v-if="[4,7].includes(t.tor_status)">
                                    <span class="text_branco">GANHOS:</span>
                                    <span v-bind:class="[t.prize>0?'text_verde':'text_vermelho']"> R${{formatarMoeda(t.prize)}} </span>
                                  </div>
                                  <div v-if="[5,6].includes(t.tor_status)">
                                    <span class="text_branco">DEVOLVIDO
                                      <span class="text_verde">
                                        R$ {{ (t.tor_status==5 || t.tor_status==6) ? t.tor_taxa_entrada:''}}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-12">
                                  <div style="margin: 10px 10px 10px 0px; border-bottom:dashed #2F313C 2px;"></div>
                                </div>
                              </div>

                              <div class="row">
                                  <div class="col-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                          <span class="text_11" v-bind:class="[t.tor_tipo_id==1?'text_roxo':t.tor_tipo_id==2?'text_verde':'text_laranja']">
                                            Tipo Torneio: {{torneio_tipo_nome(t.tor_tipo_id)}} &nbsp;&nbsp;
                                          </span>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="text_11 text_bold text_branco">Melhor Posição: {{t.max_rank}}</div>
                                        </div>
                                        <div class="col-md-6">
                                          <div class="text_14 text_cinza">{{t.tor_qtd_aposta}}/{{t.tor_max_pessoa}}</div>
                                          <div class="text_11 text_cinza">Entradas / Max</div>
                                        </div>
                                        <div class="col-md-6">
                                          <div class="text_14 text_cinza">R$ {{t.tor_taxa_entrada}}</div>
                                          <div class="text_11 text_cinza">Entrada</div>
                                        </div>
                                    </div>
                                  </div>

                                  <div class="col-6">
                                    <div class="text_11 text_branco text-end mt-4 mb-3">Status: {{torneio_status_nome(t.tor_status)}}</div>
                                    <div class="text_11 text_cinza text-end">Previsão de Termino: {{ timestamp_dataBR(t.tor_dt_termino_timestamp) }}</div>
                                  </div>
                              </div>
                            </div>

                            <!-- torneios turbo -->
                            <div v-if="t.tor_tipo_id == 4">
                              <div class="row pt-2 pb-3">
                                <div class="col-8">
                                  <div class="text_17 text_bold text_cinza"> {{t.time1_nome}} x {{t.time2_nome}} </div>
                                  <div class="text_13 text_cinza">
                                    {{ t.mercado_escolhido >= 9 && t.mercado_escolhido <= 16 ? 'CANTO' : 'GOL' }}
                                    {{nomeMercadoEscolhido(t.mercado_escolhido)}}
                                  </div>
                                  <div class="text_13 text_cinza"> Entrada: R$ {{ t.tor_taxa_entrada }}  </div>
                                  <div class="text_13 text_cinza"> Melhor Posição: {{ t.max_rank }}  </div>
                                  <div class="text_13 text_cinza"> Status: {{ torneio_status_nome(t.tor_status) }}  </div>
                                </div>
                                <div class="col-4">
                                  <div v-if="[4,7].includes(t.tor_status)">
                                    <div class="text_cinza text_12 text-end">GANHO</div>
                                    <div class="text_cinza text_12 text-end text_bold" v-bind:class="[t.prize>0?'text_verde':'text_vermelho']">R$ {{formatarMoeda(t.prize)}}</div>
                                  </div>

                                  <div v-if="[5,6].includes(t.tor_status)">
                                    <div class="text_cinza text_12 text-end">DEVOLVIDO</div>
                                    <div class="text_cinza text_12 text-end text_bold" v-bind:class="[t.prize>0?'text_verde':'']">R$ {{ (t.tor_status==5 || t.tor_status==6) ? t.tor_taxa_entrada:''}}</div>
                                  </div>
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>

                      <!-- paginate -->
                      <div class="row">
                        <div class="col-md-4">
                          <nav aria-label="...">
                            <ul class="pagination pagination-sm">
                              <li class="page-item text_cinza pe-3">Page: {{this.page}}</li>
                              <li class="page-item"><a class="page-link" href="#" @click="page_menos()"> < </a></li>
                              <li class="page-item"><a class="page-link" href="#" @click="page_add()"> > </a></li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                      <!----------->

                    </div>
                </div>

              </div>
          </div>
      </div>

      <ccFooter></ccFooter>

</div>
</template>

  <script>
  import axios from 'axios';
  import ccMenu from '../layout/menu.vue'
  import ccFooter from '../layout/footer.vue'
  import ccLoading from '../cc_geral/cc_loading.vue'

  export default {
    data () {
      return {
        //geral
        base_url_api: process.env.BASE_URL_API,
        user: {},
        loading: true,
        errors: [],

        //array
        orginal: [],
        tor: [],

        //filtro
        frm_torneio_tipo: 0,
        frm_torneio_buy_in: 'all',

        //paginação
        page: 1,
        //// page_ultimo: 99999,

        //variaveis
        qtd_total_andamento: 0,
        timer_atualizar: null,
        timer_torneio_horario: null,
      }
    },

    components: {ccMenu, ccFooter, ccLoading},

    created(){
      document.title = 'Meus Torneios: Histórico - SokkerDuel';
      localStorage.setItem("base_url_api_mobile", this.base_url_api);
    },

    mounted(){
      let a = JSON.parse(localStorage.getItem("user"));

      if (a == null){
        this.user = {}
        this.expluse_para_login()
      }else{
        this.user = a
      }

      this.get_meu_torneio()
      this.start_time_atualizar()
    },

    methods: {

      get_meu_torneio(){
        // this.loading = true;
        var body = {
          user_id: this.user.id,
          tipo_id: this.frm_torneio_tipo,
          page: this.page,
          status: 1,
          buy_in: this.frm_torneio_buy_in,
        };

        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.post(this.base_url_api+'user/torneio/historico',body, header)
        .then(response => {

          //ajuste na paginacao
          // if(response.data.resp.data.length == 0){
          //   this.page--
          //   this.get_meu_torneio()
          // }

          //receba todos os dados
          this.original = response.data.resp.data;
          this.qtd_total_andamento = this.orginal.length

          //atributos da paginacao vindo da consulta
          //this.page_ultimo = response.data.resp.page_last

          this.higienizar_filtro()

          this.loading = false

          this.atualize_menu()
        })
        .catch(e => {
          this.errors.push(e);
          this.expluse_para_login()
        });
      },

      higienizar_filtro(){
        let agora = Date.now()
        let dif = 0;
        let auxiliar = []
        var obj = {}
        this.tor = []
        var a = this.original
        this.tor = a

        auxiliar = []
        for (var i = 0; i <= a.length-1; i++) {
          if(a[i].tor_status > 3){
            obj = {
              user_id: a[i].user_id,
              tor_id: a[i].tor_id,
              tor_nome: a[i].tor_nome,
              tor_tipo_id: a[i].tor_tipo_id,
              tor_estrutura_id: a[i].tor_estrutura_id,
              tor_status: a[i].tor_status,
              tor_dt_inicio_timestamp: a[i].tor_dt_inicio_timestamp,
              tor_dt_termino_timestamp: a[i].tor_dt_termino_timestamp,
              tor_taxa_entrada: a[i].tor_taxa_entrada,
              tor_qtd_aposta: a[i].tor_qtd_aposta,
              tor_prize: a[i].tor_prize,
              tor_max_pessoa: a[i].tor_max_pessoa,
              tor_min_pessoa: a[i].tor_min_pessoa,
              max_rank: a[i].max_rank,
              prize: a[i].prize,
              fixture_id: a[i].jogo.id,
              mercado_escolhido: a[i].jogo.mercado_escolhido,
              time1_nome: a[i].jogo.time1_nome,
              time2_nome: a[i].jogo.time2_nome,
            }
            auxiliar.push(obj);
          }
        }
        this.tor = auxiliar
      },

      chamando_pagina_torneio(n){
        var self = this;
        self.$router.push({path: '/torneio/'+n});
      },

      filtro_tipo(tipo){
        this.frm_torneio_tipo = tipo
        this.get_meu_torneio()
      },

      filtro_buy_in(value){
        this.frm_torneio_buy_in = value
        this.get_meu_torneio()
      },

      start_time_atualizar(){
        this.timer_atualizar = setInterval( function(){
            this.get_meu_torneio()
        }.bind(this), 60000);
      },

      /*paginate*/
      page_add(){
        this.page > 0 ? this.page++ : this.page = 1
        this.get_meu_torneio();
      },

      page_menos(){
        this.page > 1 ? this.page-- : this.page = 1
        this.get_meu_torneio();
      },

    },

    destroyed(){
      clearInterval(this.timer_torneio_horario);
      clearInterval(this.timer_atualizar);
    },

  }
  </script>

  <style scoped>

    .form-control {
        color: #ffffff80;
        background-color: #333644;
        border: none;
    }

    .card{
      background: transparent linear-gradient(72deg, #FFFFFF00 0%, #80808033 100%) 0% 0% no-repeat padding-box;
      box-shadow: 3px 3px 8px #00000029;

    }

    .btn{
      font-size: 10px;
      border-radius: 5px;
      opacity: 1;
    }

    .btn_azul{
      color: #4968C1;
      border: 1px solid #5983F5;
    }

    .page-item{
      background-color: transparent;
    }

    .page-link{
      background-color: transparent;
      text-decoration: none;
      font-size: 15px;
      font-family: bold;
      color: #cccccc;
      border: solid 1px #20222d;
    }

  </style>



// WEBPACK FOOTER //
// src/components/meu/meu_torneio_historico.vue